(function(){
  var containerSelector = '#hs-form-container';
  var loaded = false;

  function getData(){
    var container = document.querySelector(containerSelector);
    if (!container) return null;
    return {
      portalId: container.dataset.portal,
      formId: container.dataset.form,
      region: container.dataset.region || 'na1'
    };
  }

  function pushFormSuccess(formGuid) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'hubspot_form_success',
      hs_form_guid: formGuid
    });
  }

  function loadHubspot() {
    if (loaded) return;
    loaded = true;
    var data = getData();
    if (!data || !data.portalId || !data.formId) return;

    // If embed already present, create form immediately
    if (window.hbspt && window.hbspt.forms) {
      window.hbspt.forms.create({
        portalId: data.portalId,
        formId: data.formId,
        region: data.region,
        target: containerSelector,
        onFormSubmitted: function() {
          pushFormSuccess(data.formId);
        }
      });
      return;
    }

    // Otherwise load HubSpot embed script then create form
    var s = document.createElement('script');
    s.src = 'https://js.hsforms.net/forms/embed/v2.js';
    s.async = true;
    s.defer = true;
    s.onload = function(){
      if (window.hbspt && window.hbspt.forms) {
        window.hbspt.forms.create({
          portalId: data.portalId,
          formId: data.formId,
          region: data.region,
          target: containerSelector,
          onFormSubmitted: function() {
            pushFormSuccess(data.formId);
          }
        });
      }
    };
    document.body.appendChild(s);
  }

  function init() {
    var container = document.querySelector(containerSelector);
    if (!container) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries, observer){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            loadHubspot();
            observer.disconnect();
          }
        });
      }, { rootMargin: '200px' });
      io.observe(container);
    } else {
      // Fallback: load immediately if IO not available
      loadHubspot();
    }

    // Safe fallback: force load after 5s in case intersection didn't trigger
    setTimeout(function(){ if (!loaded) loadHubspot(); }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();